import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
import { pathTypes } from '@utils/sectionEnums.js';

export function updateTimerApiCall({
  id,
  isTimer,
  timerType,
  timerTimestamp,
  timerTillDate,
  timerPosition,
  timerLabel,
  timerTitle,
  timerLinkId,

  timerBackgroundColor,
  timerTextColor,
  timerOpacity,
  timerIcon,

  isPathDesign,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.timer, isPathDesign, id), {
    id,
    isTimer,
    type: timerType,
    timestamp: timerTimestamp,
    tillDate: timerTillDate,
    position: timerPosition,
    label: timerLabel,
    title: timerTitle,
    linkId: timerLinkId,

    background_color: timerBackgroundColor,
    textColor: timerTextColor,
    opacity: timerOpacity,
    icon: timerIcon,

    sectionBorderColor,
    isSectionBackground: sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,
  });
}
